import { api } from "@lumberset/api-client";
import { HelpArticlesTable } from "@lumberset/support-ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../../components/crumbs";

export const Route = createFileRoute("/_app/help/articles/")({ component: Articles });

function Articles() {
  const navigate = useNavigate();
  return (
    <>
      <Crumbs trail={[{ label: "Help articles" }]} />
      <HelpArticlesTable
        api={api}
        onOpen={(id) => navigate({ to: "/help/articles/$id", params: { id } })}
        onNew={() => navigate({ to: "/help/articles/new", search: {} })}
      />
    </>
  );
}
